<template>
    <div>
        <div class="form-item-settings">
            <template v-if="componentConfiguration.custom.type === 'select'">
                <form-select-options-editer
                    v-if="componentConfiguration.custom.options"
                    :title="componentConfiguration.text"
                    :options="componentConfiguration.custom.options"
                    @update="$_updateCustomOptions($event)"
                />
            </template>
        </div>
    </div>
</template>

<script>
    import FormSelectOptionsEditer from './FormSelectOptionsEditer.vue';

    export default {
        name: 'print-settings-form-configuration-component',
        components: {
            'form-select-options-editer': FormSelectOptionsEditer
        },
        props: { componentConfiguration: { type: Object, required: true }, },

        data() {
            return {};
        },

        methods: {
            $_updatedForm(data) {
                Object.keys(data).forEach(field => {
                    this.componentConfiguration.custom.elements.find(({ name }) => name === field).value = data[field];
                });
                this.$emit('change', { ...this.componentConfiguration.custom });
            },
            $_onChangeValue(value){
                this.$emit('change', { ...this.componentConfiguration.custom, value });
            },
            $_onChangeCheckbox(checked){
                this.$emit('changeCheckbox', checked);
            },
            $_updateCustomOptions(newValue) {
                this.$emit('updateOptions', newValue);
            }
        }
    };
</script>

<style scoped>
    .form-item-settings {
        margin-bottom: 8px;
        margin-top: 8px;
        margin-left: 20px;
    }
</style>
